import { useRef }                               from 'react';
import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react';

const VARIANTS = {
    success: { header: 'bg-[#2e9e5b]',          icon: '✓' },
    error:   { header: 'bg-red-600',            icon: '!' },
    confirm: { header: 'bg-azul-profundo-m',    icon: '?' },
}

// Modal de mensagem: sucesso, erro do backend ou confirmação de uma ação.
// feedback = { type: 'success' | 'error' | 'confirm', title, message, confirmLabel, onConfirm }
function FeedbackModal({ feedback: currentFeedback, onClose, isConfirming = false }) {

    // Mantém o último conteúdo durante a animação de saída; sem isso o modal
    // piscaria com o visual vazio quando feedback vira null.
    const _lastFeedback = useRef(currentFeedback)
    if (currentFeedback) _lastFeedback.current = currentFeedback
    const feedback = currentFeedback ?? _lastFeedback.current

    const variant = VARIANTS[feedback?.type] ?? VARIANTS.success
    const isConfirm = feedback?.type === 'confirm'

    return (

        <Dialog open={!!currentFeedback} onClose={isConfirming ? () => {} : onClose} className="relative z-[110]">

            <DialogBackdrop transition className="fixed inset-0 bg-bg-backdrop transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200"/>

            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">

                <div className="flex min-h-full items-center justify-center p-4">

                    <DialogPanel transition className="w-full max-w-[460px] overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:scale-95 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200">

                        <header className={`${variant.header} flex items-center gap-3 px-4 py-3`}>

                            <span className="flex items-center justify-center w-[24px] h-[24px] rounded-full bg-white/25 text-white font-bold">
                                {variant.icon}
                            </span>

                            <h2 className="text-white text-[1rem] leading-7 font-semibold">{feedback?.title}</h2>

                        </header>

                        <p className="px-4 py-5 text-[0.95rem] text-cinza-escuro whitespace-pre-line">
                            {feedback?.message}
                        </p>

                        <footer className="flex gap-2 justify-end bg-gray-50 px-4 py-3">

                            {isConfirm ? (<>

                                <button type="button" onClick={onClose} disabled={isConfirming} className="btn btn-cinza px-4 disabled:opacity-50">
                                    Cancelar
                                </button>

                                <button type="button" onClick={feedback.onConfirm} disabled={isConfirming} className="btn btn-vermelho px-4 disabled:opacity-50">
                                    {isConfirming ? 'Aguarde...' : (feedback.confirmLabel ?? 'Confirmar')}
                                </button>

                            </>) : (

                                <button type="button" onClick={onClose} className="btn btn-azul-prof px-6">
                                    OK
                                </button>

                            )}

                        </footer>

                    </DialogPanel>

                </div>

            </div>

        </Dialog>
    )
}

export default FeedbackModal
